<template>
  <!-- /todo.. navar fixed only after refresh -->
<div id="app">
<!-- <div class="scroller" style="overflow: auto; height: 100px;">
        <pre id="logger" style="height: 500px; text-transform:capitalize; background-color: #f5f5f5; margin-bottom: 0;"></pre>
    </div>    -->
  <component :is="layout">
    <transition name="fade" mode="out-in">
      <router-view :key="$route.path" />
    </transition>
    <vue-progress-bar></vue-progress-bar>

    <div
      id="v-step-0"
      :class="{hidden:onLine}"
      class="p-4 alert alert-danger alert-dismissible fade show"
      role="alert"
    >
      <strong>Offline!</strong> Could not connect to the server.
    </div>
    <AudioPlayer />
  </component>

  
  </div>
</template>
 
<script>
const default_layout = "default";
import AudioPlayer from "@/components/common/AudioPlayer";

import NoNavBar from "@/layouts/NoNavBar";
import Default from "@/layouts/Default";
import { mapState } from "vuex";
import { checkTURNServer } from "@/plugins/utils";
export default {
  name: "App",
  components: {
    AudioPlayer,
    "default-layout": Default,
    "no-nav-layout": NoNavBar,
  },

  computed: {
    ...mapState({
      onLine: (state) => state.auth.onLine,
    }),

    layout() {
      const layout = this.$route.meta.layout;
      if (layout === "no-nav") return "no-nav-layout";
      else if (layout === "default") return "default-layout";
    },
  },

  watch: {
    onLine(v) {
      this.$store.commit("SET_IS_ONLINE", v);
    }
  },

  async created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },

  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.$store.commit("SET_IS_ONLINE", type === "online");
    },
  },

  mounted() {
  

//    checkTURNServer(
    

//    { 
//          urls: "turn:audio.ownaradio.com:3478",
//          username: "shaibu",
//          credential: "secret",
//        },         
  
//   ).then(function(bool){
//      console.log('is TURN server active? ', bool? 'yes':'no');
//  }).catch(console.error.bind(console));

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>
<style lang="scss" scoped>
#notification,
#notification_connectionDead {
  position: fixed;
  right: 4px;
  top: 40px;
  z-index: 222;
  height: 60px;
  min-width: 270px;
  // display: none;
}
.hidden {
  display: none;
}
</style>
